import { ref } from "vue";

interface UseContactFormOptions {
    hookUrl: string;
    privacyPolicyHidden: boolean;
    validationMessage: string;
    successMessage: string;
    errorMessage: string;
}

export function useContactForm(options: UseContactFormOptions) {
    const agreed = ref(options.privacyPolicyHidden);
    const formSubmitted = ref(false);
    const isSubmitting = ref(false);
    const showSuccessMessage = ref(false);
    const showErrorMessage = ref(false);

    const handleSubmit = async (e: Event) => {
        e.preventDefault();
        formSubmitted.value = true;

        if (!agreed.value) {
            return;
        }

        isSubmitting.value = true;
        const formData = Object.fromEntries(new FormData(e.target as HTMLFormElement));

        try {
            await fetch(options.hookUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(formData),
            });

            isSubmitting.value = false;
            showSuccessMessage.value = true;
        } catch (error) {
            isSubmitting.value = false;
            showErrorMessage.value = true;
        }
    };

    return {
        agreed,
        formSubmitted,
        isSubmitting,
        showSuccessMessage,
        showErrorMessage,
        handleSubmit,
    };
}
